import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import HighchartsMap from 'highcharts/modules/map';
import {Card, CardContent} from '@mui/material';

interface IChartContainerProps {
    options: Highcharts.Options;
    chartType?: string
}

export function HighChartContainer({options, chartType}: IChartContainerProps) {
    if (chartType === 'mapChart') {
        HighchartsMap(Highcharts);
    }   

    return (
        <Card className='chart-container'>
            <CardContent>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={options}
                    constructorType={chartType || 'chart'}
                />
            </CardContent>
        </Card>
    )
}